const TimeStamp = ({ time }: { time: string }) => {
  return (
    <div className='flex w-full justify-center'>
      <p className='rounded-full bg-grey-090/20 px-2 py-1 text-caption1 text-grey-000'>
        {time}
      </p>
    </div>
  );
};

export default TimeStamp;
